export default __webpack_public_path__ + "static/media/675.ab09dc8e.gif";